import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-100 border-t border-background-200" role="contentinfo">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-book-open-line text-background-50 text-xl"></i>
              </div>
              <span className="font-heading text-xl font-bold text-foreground-900">
                八仔漫画网
              </span>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed">
              八仔漫画网致力于为广大漫画爱好者提供优质的在线免费漫画阅读体验。无需付费，无广告干扰，纯净阅读环境，让您沉浸于精彩剧情中。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-foreground-900 mb-4">快速导航</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">首页</Link></li>
              <li><Link to="/category/全部" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">漫画分类</Link></li>
              <li><Link to="/about" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">关于我们</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-foreground-900 mb-4">热门分类</h4>
            <ul className="space-y-2">
              <li><Link to="/category/热血" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">热血漫画</Link></li>
              <li><Link to="/category/恋爱" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">恋爱漫画</Link></li>
              <li><Link to="/category/玄幻" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">玄幻漫画</Link></li>
              <li><Link to="/category/搞笑" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">搞笑漫画</Link></li>
              <li><Link to="/category/科幻" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">科幻漫画</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-foreground-900 mb-4">联系我们</h4>
            <ul className="space-y-2">
              <li className="flex items-start gap-2 text-sm text-foreground-600">
                <i className="ri-mail-line text-primary-500 mt-0.5"></i>
                <span>contact@bazaimanhua.com</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-foreground-600">
                <i className="ri-customer-service-2-line text-primary-500 mt-0.5"></i>
                <span>在线客服：工作日 9:00-18:00</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-foreground-600">
                <i className="ri-map-pin-line text-primary-500 mt-0.5"></i>
                <span>中国北京市朝阳区</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-background-200">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-4 flex flex-col sm:flex-row items-center justify-between gap-2">
          <p className="text-xs text-foreground-500">
            &copy; {currentYear} 八仔漫画网 - 版权所有 | 本站所有漫画均来自网络，仅供学习交流使用
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors cursor-pointer">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors cursor-pointer">服务条款</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors cursor-pointer">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}